<template>
  <el-button
    v-if="!hasOneBranch"
    type="default"
    text
    size="default"
    data-testid="uod-branch-context-trigger"
    @click="toggle"
  >
    <el-tooltip
      :content="location"
      :disabled="!showLocationTooltip"
      placement="bottom"
    >
      <span
        class="inline-block max-w-[12rem] truncate align-bottom"
        data-testid="uod-branch-context-trigger-label"
      >
        {{ displayLocation }}
      </span>
    </el-tooltip>
    <el-icon class="el-icon--right">
      <arrow-up-icon v-if="show" />
      <arrow-down-icon v-else />
    </el-icon>
  </el-button>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useBranchesStore } from '@shared/store/branches'
import { useLocationStore, allBranches } from '@shared/store/location'
import { ArrowUpIcon, ArrowDownIcon } from '@shared/assets/icons'

const BRANCH_NAME_MAX_LENGTH = 30

export default {
  components: {
    ArrowUpIcon,
    ArrowDownIcon
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  emits: ['toggle'],
  setup() {
    const branchesStore = useBranchesStore()
    const { branchesCount } = storeToRefs(branchesStore)
    const locationStore = useLocationStore()
    const { currentBranchName } = storeToRefs(locationStore)
    return { branchesCount, locationStore, currentBranchName }
  },
  computed: {
    hasOneBranch() {
      return this.branchesCount === 1
    },
    isBranchNameLabel() {
      return (
        this.currentBranchName && this.currentBranchName !== allBranches.label
      )
    },
    location() {
      if (!this.currentBranchName) {
        this.locationStore.$reset()
        return this.$t('nav.main.items.location.select_placeholder')
      }

      if (this.currentBranchName === allBranches.label) {
        return this.$t('nav.main.items.location.set_all')
      }

      return this.currentBranchName
    },
    displayLocation() {
      if (
        !this.isBranchNameLabel ||
        this.location.length <= BRANCH_NAME_MAX_LENGTH
      ) {
        return this.location
      }

      return `${this.location.slice(0, BRANCH_NAME_MAX_LENGTH)}...`
    },
    showLocationTooltip() {
      return (
        this.isBranchNameLabel && this.location.length > BRANCH_NAME_MAX_LENGTH
      )
    }
  },
  methods: {
    toggle() {
      this.$emit('toggle')
    }
  }
}
</script>
